// Modules
import React from "react";
import DatePicker from "react-datepicker";
import moment from 'moment';

// Styles
import "./MvDatePicker.sass";
import "react-datepicker/dist/react-datepicker.css";

// Components
import ToolTip from "../ToolTip";
import MvIcon from "../../Generic/MvIcon";

type Tip = {
  label:string;
  desc:string;
};

type Props = {
  id?:string
  name: string;
  onChange: (e:any) => void;
  selected?: Date | null;
  value: string | number | void | Date | undefined
  placeholder: string;
  required : boolean;
  items: any;
  toolTip?: [Tip];
  errorMessage?:string;
  softError?:string;
  errorStyle?: React.CSSProperties;
  hardError?:string;
  tabIndex?:number;
  isDateChanged:boolean;
  nextAvailableDate?:string;
}

type ChangingData = {
  inputValue: any;
  datePickerIsOpen:boolean;
  error: boolean;
  open: boolean;
  showSoftError: boolean,
  showInvalidDateError: boolean
}

class MvDatePicker extends React.Component<Props, ChangingData, {}> {
  constructor(props:Props) {
    super(props);
    this.handleInput = this.handleInput.bind(this);
    this.onChange = this.onChange.bind(this);
    this.changeAriaLabel = this.changeAriaLabel.bind(this);
    this.openOrCloseDatePicker = this.openOrCloseDatePicker.bind(this);
    this.drawResult = this.drawResult.bind(this);
    this.getEndRange = this.getEndRange.bind(this);
    this.state = {
        inputValue: this.props.value,
        datePickerIsOpen: false,
        error: false,
        open: false,
        showSoftError: false,
        showInvalidDateError: false
    }
  }
  componentDidUpdate(prevProps: Props) {
    if (prevProps.isDateChanged !== this.props.isDateChanged) {
      this.setState({ inputValue: this.props.nextAvailableDate });
    }
  }
  
  handleInput(e:any) {
    let value = moment(e).format('MM/DD/YYYY');

    this.props.onChange({
      target: {
        name: this.props.name,
        value: value
      }
    });

    this.setState({
      inputValue: value,
      datePickerIsOpen: false
    })

  }

  onChange(e:any) {
    let value = moment(e).format('MM/DD/YYYY');
    let event = {
      target: {
        name: this.props.name,
        value: value
      }
    };
    this.props.onChange(event);
  }

  openOrCloseDatePicker(decision:boolean, doesErrorExist:any) {
    if(doesErrorExist) {
      this.setState({showSoftError:true, inputValue:""});

    }

    this.setState({
      datePickerIsOpen: decision
    });
  };

  formatReplaceEmail = (input: string, e: any) => {
    // Strip all characters from the input except digits
    input = input.replace(/[^0-9]/g,'');
    
    // backspace
    if (e.keyCode === 8) {
      input = input.slice(0, - 1);
    }

    const size = input.length;

    // Based upon the length of the string, we add formatting as necessary
    if (size < 2) {
      input = input;  
    } else if (size === 2) {
        input = input + '/';
    } else if (size === 3) {
        input = input.slice(0, 2) + '/' + input.slice(2);
    } else if (size === 4) {
        input = input.slice(0, 2) + '/' + input.slice(2) + '/';
    } else if (size > 4) {
        input = input.slice(0, 2) + '/' + input.slice(2, 4) + '/' + input.slice(4, 8);
    } 

    return input; 
  } 

  checkIfDateValidSubmit = (val: any, inputValue: any) => {
    console.log({isvalid: val.isValid()})
    if(!val.isValid()) {
      if(inputValue.length === 10) {
        this.setState({
          error: true,
          open: true,
          showInvalidDateError: true,
          inputValue: ""
        });
      }
      return false;
    } 
    val = moment(val).format('MM/DD/YYYY');

    //If the date is not in range, then error out and force user to enter valid date
    if(!this.errorValidation(val)) {
      return false;
    }
    
    let event = {
      target: {
        name: this.props.name,
        value: val
      }
    };
    this.props.onChange(event);

    return true;
  };

  // if tab or enter, continue
  // any other key, try to parse/format as date using formatReplaceEmail()
  onKeyDownDateType = (e: any) => {
    // tab or enter
    if ((e.keyCode === 9 || e.keyCode === 13)) {
        // don't bubble enter key
        if(e.keyCode === 13) {
          e.stopPropagation();
          e.preventDefault();
        }

        let val: any = moment(this.state.inputValue, 'MM/DD/YYYY', true);

        if (this.checkIfDateValidSubmit(val, this.state.inputValue)) {
          this.setState({
            datePickerIsOpen: false
          });
        }
    } else {
      let inputValue = e.key;
      const concatedValue = this.state.inputValue + inputValue;
      inputValue = this.formatReplaceEmail(concatedValue, e);
      this.setState({ inputValue }, () => {
        let val: any = moment(inputValue, 'MM/DD/YYYY', true);

        this.checkIfDateValidSubmit(val, inputValue);
      });
    }
  }

  errorValidation(val:any) {
    let minAndMax = this.props.items
    let {0: min, [minAndMax.length - 1] :max } = minAndMax;

    let beginRange = moment().format('MM/DD/YYYY');
    let endRange = moment(max.value).add(1, 'days').format('MM/DD/YYYY');
    let compareDates = moment(val).isBetween(beginRange, endRange);

    console.log("state ==> " + JSON.stringify(this.state));

    if (compareDates === false) {
      this.setState({
        error: true,
        open: true,
        showSoftError: true,
        inputValue: "",
        showInvalidDateError: false
      });
      return false;
    } else {
      let event = {
        target: {
          name: this.props.name,
          value: ""
        }
      };
      this.props.onChange(event);

      this.setState({
        error: false,
        inputValue: val
      });
      return true;
    }
  }

  changeAriaLabel() {
    if(this.state.error) {
      return "Invalid Date"
    } else if (!this.state.error) {
      if(this.state.inputValue === "") {
        return "Date in mm/dd/yyyy"
      } else {
        return "Date selected"
      }
    }
  }

  drawResult() {
    this.setState({
      open: false,
      showSoftError: false
    });
  }

  getEndRange() {
    let minAndMax = this.props.items
    let {0: min, [minAndMax.length - 1] :max } = minAndMax;
    let maxValue:any = max.value
    return maxValue
  }

  openToDate(val: any) {
    return moment(val).toDate();
  }

  emptyIfError(error:any){
    if (error) {
      this.setState({
        inputValue: ""
      });
    }
  }

  render() {
    let ariaLabel = this.changeAriaLabel()
    // START This will be removed when Experience API call is in place. Just for show, at the moment
    let endRange = this.getEndRange();
    let today = moment().format('MM/DD/YYYY')
    // END This will be removed when Experience API call is in place.

    let prev:any = document.getElementsByClassName('react-datepicker__navigation--previous');
    let next:any = document.getElementsByClassName('react-datepicker__navigation--next');
    prev = prev[0];
    next = next[0];

    if (prev != undefined ) {
      prev.setAttribute('aria-hidden', true);
      prev.setAttribute('tabindex', '-1')
    }
    if (next != undefined ) {
      next.setAttribute('aria-hidden', true);
      next.setAttribute('tabindex', '-1')
    }

    let err;
    if(this.state.showSoftError) {
      err = this.props.softError
    }

    if(this.state.showInvalidDateError) {
      err = "Invalid date";
    }

    return (

      <div onBlur={this.drawResult}
        className={
          "mv-datepicker " +
          (err ? "error" : "")
        }>
        {(this.state.error) && (
          <React.Fragment>
            <div role="alert" aria-live="polite" aria-label="Invalid date. Please select a date in range"></div>
            <MvIcon
              icon="exclamation"
              color="red"
              style={{ position: "absolute", left: "-11px", top: "-15px" }}
              height="13px"
              width="13px"
            />
          </React.Fragment>
        )}

        <DatePicker
          customInput={
            <React.Fragment>
              <input
                tabIndex={this.props.tabIndex}
                className="exact-date-input"
                placeholder={this.props.placeholder}
                autoComplete="off"
                type="text"
                maxLength={10}
                id="date-input"
                aria-label={ariaLabel}
                value={this.state.inputValue}
                onKeyDown={this.onKeyDownDateType}
                onClick={()=>this.openOrCloseDatePicker(true, this.state.error)}
                onFocus={()=>this.openOrCloseDatePicker(true, this.state.error)}
                onBlur={()=>this.emptyIfError(this.state.error)}
              />
            </React.Fragment>
          }
          openToDate={this.openToDate(this.props.value)}
          tabIndex={-1}
          selected={this.openToDate(this.props.value)}
          customInputRef="dateInput"
          autoComplete="off"
          id={this.props.id}
          onChange={this.handleInput}
          required={this.props.required}
          minDate={moment(today).toDate()}
          maxDate={moment(endRange).toDate()}
          open={this.state.datePickerIsOpen}
          onClickOutside={()=>this.openOrCloseDatePicker(false, this.state.error)}
        />

        <div className="error tool-tip">
          <div
            className={"tool-tip-popup " + (err && this.state.open ? "show" : "")}
            style={this.props.errorStyle}
          >
            <p>{err}</p>
          </div>
        </div>

        {this.props.toolTip && <ToolTip useRefToPosition={false} tip={this.props.toolTip} id='datepicker-tooltip' />}
        {this.props.required && <span className="abs">*</span>}
      </div>
    );
  }
}

export default MvDatePicker;
